export default "__VITE_ASSET__y8KcI1B7__"